import { useQuery } from "@tanstack/react-query";
import PreferenceService from "../../services/PreferenceService";

const useFilterPreference = (options = {}) => {
  return useQuery({
    ...options,
    queryKey: ["filter-preference"],
    queryFn: async () => {
      const res = await PreferenceService.getFilter();
      return res.data;
    },
  });
};

export default useFilterPreference;
